import { useSessionStore } from "@/features/tutor/store/useSessionStore";
import { useUIStore } from "@/features/tutor/store/useUIStore";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exitLesson } from "@/features/tutor/utils/endLesson";
import { captureAndUploadSlideScreenshot } from "@/features/tutor/utils/slideScreenshot";
import { useRuntimeContext } from "@/features/tutor/context/RuntimeContext";
import { useNotificationStore } from "@/store/useNotificationStore";

const EndLessonButton = ({ compact = false }) => {
  const sessionId = useSessionStore((s) => s.sessionId);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { emit } = useRuntimeContext();

  const handleClick = async () => {
    window.dispatchEvent(new CustomEvent("user:activity"));
    if (!sessionId) {
      emit("LOCAL_INTERRUPT");
      await captureAndUploadSlideScreenshot();
      exitLesson(navigate, searchParams);
      return;
    }
    useNotificationStore.getState().cancelAllNotifications();
    useUIStore.getState().setShowExitLessonModal(true);
  };

  if (compact) {
    return (
      <button
        onClick={handleClick}
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "9999px",
          backgroundColor: "#ea615d",
        }}
        className="flex items-center justify-center text-white focus:outline-none hover:opacity-90 active:opacity-80 transition-opacity duration-200"
        title="End Lesson"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            points="16 17 21 12 16 7"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="21"
            y1="12"
            x2="9"
            y2="12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      style={{
        width: "142px",
        height: "47px",
        borderRadius: "10px",
        backgroundColor: "#ea615d",
      }}
      className="flex items-center justify-center text-white focus:outline-none hover:opacity-90 active:opacity-80 transition-opacity duration-200"
    >
      <span
        style={{
          fontFamily: "Mulish, sans-serif",
          fontWeight: 700,
          fontSize: "14px",
        }}
      >
        Exit Lesson
      </span>
    </button>
  );
};

export default EndLessonButton;
